var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"registration"},[_c('div',{staticClass:"container"},[_c('RegistrationForm',{on:{"showTerms":_vm.showTerms,"showPrivecy":_vm.showPrivecy}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }